import React from "react";
import InfoBox from "../boxes/InfoBox";
import { t } from "../../i18n";

interface Props {
  className?: string;
}

const DataProcessingInfo = ({ className }: Props): JSX.Element => {
  return (
    <InfoBox className={className}>
      <span dangerouslySetInnerHTML={{ __html: t("registration.tips.data_processing") }}/>
    </InfoBox>
  );
}

export default DataProcessingInfo;
